import type { ChatSettings } from '../types';

export const defaults: Partial<ChatSettings> = {
  bubbleIcon: {
    url: 'https://static.elfsight.com/icons/facebook-messenger.svg'
  },
  buttonText: 'Chat on Facebook',
  welcomeMessage: 'Hi there!👋 <br><br> How can I help you?',
  headerBackgroundColor: 'rgb(250, 250, 250)',
  buttonColor: { type: 'native', color: 'rgb(0, 132, 255)' },
  bubbleBackgroundColor: 'rgb(10, 124, 255)',
  bubbleIconColor: 'rgb(255, 255, 255)',
  buttonBorderRadius: 16,
  messageBackgroundColor: 'rgb(239, 239, 239)',
  align: 'right',
  infoFromFacebook: true
};
